document.addEventListener('DOMContentLoaded', function() {
  const benefitSection = document.querySelector('.shop-by-benefit-section');
  if (!benefitSection || window.innerWidth <= 990) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        initBenefitHovers();
        observer.disconnect();
      }
    });
  }, { rootMargin: '100px' });

  observer.observe(benefitSection);

  function initBenefitHovers() {
    const allBenefits = document.querySelectorAll('[data-show-image]');
    const mainImage = document.querySelector('.main-benefit-image');

    allBenefits.forEach(function(benefit) {
      benefit.addEventListener('mouseover', function(e) {
        const imgSelector = e.target.getAttribute('data-show-image');
        const targetImg = document.querySelector('[data-image="' + imgSelector + '"]');
        if (mainImage) mainImage.classList.add('fade-out');
        if (targetImg) targetImg.classList.add('show-benefit');
      });

      benefit.addEventListener('mouseout', function(e) {
        const imgSelector = e.target.getAttribute('data-show-image');
        const targetImg = document.querySelector('[data-image="' + imgSelector + '"]');
        if (mainImage) mainImage.classList.remove('fade-out');
        if (targetImg) targetImg.classList.remove('show-benefit');
      });
    });
  }
});
